"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_i18next_1 = require("react-i18next");
var ParamExtractor_1 = require("@wix/dealer-common/dist/src/services/ParamExtractor");
var Catch_1 = require("../../Catch");
// @translate('', {wait: true})
var CmsTextComp = /** @class */ (function (_super) {
    tslib_1.__extends(CmsTextComp, _super);
    function CmsTextComp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sanitizedObjectFunc = function (translatedValue) { return ({ __html: translatedValue }); };
        _this.replaceDynamicParams = function (text, dynamicParams) {
            return text.replace(/\[\[(.*?)\]\]/g, function () {
                var params = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    params[_i] = arguments[_i];
                }
                return dynamicParams[params[1]] || params[0];
            });
        };
        _this.getTranslatedValue = function () {
            var context = _this.props.context;
            var staticParams = ParamExtractor_1.getStaticParams(_this.props.element, context) || {};
            var dynamicParams = ParamExtractor_1.getDynamicParams(_this.props.element, context) || {};
            var dealerOptions = _this.props.dealerOptions || {};
            var paramsToReplace = tslib_1.__assign({}, dealerOptions, dynamicParams);
            var text = _this.props.t(_this.props.element.textKey, staticParams);
            return _this.replaceDynamicParams(text, paramsToReplace);
        };
        return _this;
    }
    CmsTextComp.prototype.render = function () {
        var _this = this;
        return Catch_1.Catch({
            onError: this.props.onError,
            render: function () {
                return (React.createElement("span", { dangerouslySetInnerHTML: _this.sanitizedObjectFunc(_this.getTranslatedValue()) }));
            },
        });
    };
    return CmsTextComp;
}(React.Component));
exports.CmsTextComp = CmsTextComp;
exports.CmsText = react_i18next_1.translate('', { wait: true })(CmsTextComp);
//# sourceMappingURL=CmsText.js.map